import React, { useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Visibility, History } from "@mui/icons-material";
import { useAppointmentStore } from "../../stores/useAppointmentStore";

const UpcomingAppointmentsTable = ({ onViewDetails, onViewHistory }) => {
  const { appointments, isLoading, getAppointments } = useAppointmentStore();

  useEffect(() => {
    getAppointments();
  }, []);

  if (isLoading)
    return (
      <div className="flex justify-center py-5">
        <CircularProgress />
      </div>
    );

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Patient</TableCell>
          <TableCell>Slot</TableCell>
          <TableCell>Reason to Visit</TableCell>
          <TableCell>Status</TableCell>
          <TableCell align="right">Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {appointments.map((appt) => (
          <TableRow key={appt._id}>
            <TableCell>{appt.patientName}</TableCell>
            <TableCell>{appt.slot}</TableCell>
            <TableCell>{appt.reason}</TableCell>
            <TableCell>{appt.status}</TableCell>
            <TableCell align="right">
              <IconButton onClick={() => onViewDetails(appt)}>
                <Visibility />
              </IconButton>
              <IconButton onClick={() => onViewHistory(appt)}>
                <History />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default UpcomingAppointmentsTable;
